const getters = {
	appid(state, getters) {
		return state.appid;
	},

	redirectURL(state, getters) {
		return state.redirectURL;
	}
};

export default getters